import { Box, IconButton, ImageList, ImageListItem, Typography } from '@mui/material'
import React, { useCallback } from 'react'
import ContainerButton from '../../../../components/button/ContainerButton';
import { getBaseApi } from '../../../../utils/app.utils';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import clsx from 'clsx';

type dataProps = {
    id_media_file: number, media_file_path: string, media_file_name: string
}
type Props = {
    data: dataProps[];
    onAdd?: () => void;
    is_delete?: boolean;
    handleDeleteImage?: (index_file: number) => void;
    onDeleteClick?: () => void;
    disabled_delete?: boolean;
    view?: boolean;
}


function StandardImageList(
    base_image_url: string,
    itemData: dataProps[],
    is_delete?: boolean,
    handleDeleteImage?: (index_file: number) => void
) {
    return (
        <ImageList sx={{ width: "100%", height: "100%", overflow: "auto" }} cols={4} rowHeight={"auto"}>
            {itemData.map((item, index) => {
                const url_image = `${base_image_url}/${item?.media_file_path}${item?.media_file_name}`
                return (

                    <ImageListItem className='relative' key={`${item.id_media_file}-${index}`}>
                        {is_delete && (
                            <IconButton color='error' onClick={() => handleDeleteImage?.(index)} sx={{ border: "1px solid red", zIndex: 10, position: "absolute", left: "50%", top: "50%", transform: "translate(-50%,-50%)" }}>
                                <DeleteForeverIcon />
                            </IconButton>
                        )}
                        <img
                            className={clsx('', {
                                'opacity-45': is_delete
                            })}
                            srcSet={`${url_image}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
                            src={`${url_image}?w=164&h=164&fit=crop&auto=format`}
                            alt={`item-${item.id_media_file}`}
                            loading="lazy"
                        />
                        <Typography noWrap textAlign={"center"} py={2}>
                            {item?.media_file_name || "-"}
                        </Typography>
                    </ImageListItem>
                )
            })}
        </ImageList>
    );
}
const ImageUploadContent: React.FC<Props> = ({ onAdd, data, is_delete, view, onDeleteClick, disabled_delete, handleDeleteImage }: Props) => {
    const base_image_url = getBaseApi()
    return (
        <Box className="w-full py-5 h-full">
            <Box className="border-2 flex justify-between flex-col items-center border-[#DDE1EB]" sx={{
                width: "100%",
                p: 3,
                borderRadius: 4,
                height: '100%',
                minHeight: "811px",
                position: "relative"
            }}>
                <Box className="w-full flex-1 flex-col overflow-y-auto">
                    {StandardImageList(base_image_url, data, is_delete, handleDeleteImage)}
                </Box>
                <Box className="flex bg-[#F2F4F7] px-4 justify-end items-center w-full h-[92px]">
                    {!view && (
                        <ContainerButton
                            justifyContent='flex-end'
                            buttonData={[
                                {
                                    key: "ADD",
                                    label: "เพิ่ม",
                                    seq: 1,
                                    type: "ADD",
                                    buttonProps: {
                                        onClick: onAdd
                                    },
                                },
                                {
                                    key: "DELETE",
                                    label: is_delete ? "ตกลง" : "ลบ",
                                    seq: 2,
                                    type: "DELETE_BIN",
                                    buttonProps: {
                                        disabled: disabled_delete,
                                        onClick: onDeleteClick
                                    },
                                },
                            ]}
                        />
                    )}
                </Box>
            </Box>
        </Box>
    )
}

export default ImageUploadContent